module.exports = __webpack_public_path__ + "product-raw-grass-08.jpg?b0458e1f4b171dc793f8d2030cb8d6cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-raw-grass-08.jpg
// module id = 23
// module chunks = 0